/**
 * The Termini e Condizioni / Informativa Privacy confirmation before an Apple /
 * Google purchase — in the paywall under the «Scegli» buttons; the Shop shows
 * the same sentence (shop widget).
 *
 * Since 05/11/2026 a sentence instead of a box: going on to the store sheet is
 * the acceptance (client). Word for word the backend's own sentence
 * (PurchaseConsentCatalog, `terms_privacy_notice`), which is what it records as
 * proof; a test keeps the two equal. Store purchases never carry the
 * immediate-access/withdrawal confirmation: Apple and Google apply their own
 * refund rules (client, 05/10/2026).
 */
export const STORE_PURCHASE_CONSENT = "terms_privacy_notice";

export const STORE_PURCHASE_NOTICE_SEGMENTS = [
  { type: "text", value: "Continuando, accetti i " },
  { type: "link", document: "terms", label: "Termini e Condizioni" },
  { type: "text", value: " e dichiari di aver preso visione dell'" },
  { type: "link", document: "privacy", label: "Informativa Privacy" },
  { type: "text", value: "." },
];

/** The sentence as read, links reduced to their labels. */
export const consentPlainText = (segments) =>
  segments
    .map((segment) => (segment.type === "link" ? segment.label : segment.value))
    .join("");

/** Which in-app legal page each link opens (see pages/Legal). */
export const LEGAL_SLUG_BY_DOCUMENT = {
  terms: "terms",
  privacy: "privacy-policy",
};
